import { configureStore } from "@reduxjs/toolkit";
import { homeSlice } from "./homeSlice";
import { authSlice } from "./authSlice";
import { employeeSlice } from "./employeeSlice";
import { appEndpoints } from "../endpoints/app.endpoints";
import { holidaysSlice } from "./holidaysSlice";
import { leavesSlice } from "./leaveRequestSlice";
import { dashboardSlice } from "./userDashboardSlice";
import { admindashboardSlice } from "./adminDashboardSlice";
import { vehicleSlice } from "./vehicleSlice";

export const store = configureStore({
  reducer: {
    [appEndpoints.reducerPath]: appEndpoints.reducer,
    [authSlice.name]: authSlice.reducer,
    [homeSlice.name]: homeSlice.reducer,
    [employeeSlice.name]: employeeSlice.reducer,
    [holidaysSlice.name]: holidaysSlice.reducer,
    [leavesSlice.name]: leavesSlice.reducer,
    [dashboardSlice.name]: dashboardSlice.reducer,
    [admindashboardSlice.name]: admindashboardSlice.reducer,
    [vehicleSlice.name]: vehicleSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(appEndpoints.middleware),
  devTools: process.env.NODE_ENV === "development",
});

export type RootState = ReturnType<typeof store.getState>;
